module.exports = __webpack_public_path__ + "arrow.01d23380.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/arrow.svg
// module id = JXKF
// module chunks = 0